import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

export const techdocsStatsPlugin = createPlugin({
  id: 'techdocs-stats',
});

export const EntityTechDocsStatsCard = techdocsStatsPlugin.provide(
  createComponentExtension({
    name: 'EntityTechDocsStatsCard',
    component: {
      lazy: () =>
        import('./components/EntityTechDocsStatsCard').then(
          m => m.EntityTechDocsStatsCard,
        ),
    },
  }),
);
